import React from 'react';

import Grid from '@mui/material/Grid';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

import airbnb from 'src/App/assets/airbnbMini.svg';
import { UserListingInfoBar } from 'src/App/HOC';
import { TooltipCard } from '../../HOC';
import { COLOR_RED, COLOR_TOOLTIP_BACKGROUND, MID_GREY } from 'src/const';
import { Listing, ListingLegacy } from 'src/interfaces/idashboard';
import { Alert, Box, Button, Card, CardContent, Typography } from '@mui/material';
import {
  COLOR_ERROR_1,
  COLOR_ERROR_BACKGROUNG,
  COLOR_PRIMARY_1,
  COLOR_SUCCESS_1,
  COLOR_SUCCESS_BACKGROUNG,
  COLOR_TERTIARY_1_100,
  COLOR_TERTIARY_1_800,
} from 'src/colors';
import { SelecFilterChip } from 'src/App/Components/Chips';
import { isDateBeforeFourWeeks } from 'src/utils/functions';
import { InfoTooltip } from 'src/App/HOC/Tooltips';

const TopBar = ({
  onClose,
  isMobileScreen,
  data,
  isCompListing,
}: {
  onClose;
  isMobileScreen: boolean;
  data: any[] | Listing;
  isCompListing?: boolean;
}) => {
  const listingLastSeenBeforeFourWeeks = isDateBeforeFourWeeks(data['last_seen']);

  return (
    <>
      <Grid
        justifyContent="space-between"
        direction="row"
        alignItems="center"
        container
        style={{ paddingBottom: '15px', paddingLeft: isMobileScreen ? '20px' : 'auto' }}
        item
        xs={12}
      >
        <Grid
          item
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          gap={2}
          // sx={{ backgroundColor: 'red' }}
          xs={7}
          sm={11}
          md={11}
          lg={11}
        >
          <Grid item xs={1} sm={1} md={1} lg={1}>
            <img src={airbnb} style={{ width: 30, height: 30 }} />
          </Grid>
          {!isMobileScreen && data['last_seen'] && (
            <InfoTooltip
              // title={<TooltipCard content="We update listing status every Wednesday." />}
              title={
                matchMedia('(hover:hover)').matches ? (
                  <Card>
                    <CardContent style={{ background: COLOR_TOOLTIP_BACKGROUND }}>
                      <Typography variant="body2" style={{ fontWeight: 500, color: MID_GREY }}>
                      We update listing status every Wednesday.
                      </Typography>
                    </CardContent>
                  </Card>
                ) : (
                  <></>
                )
              }
            >
              <Alert severity="info">
                <Typography variant="body2">
                  This listing was last seen active by our system on {data['last_seen']}
                </Typography>
              </Alert>
            </InfoTooltip>
          )}
          <Grid item xs={3} sm={3} md={3} lg={3}>
            {!listingLastSeenBeforeFourWeeks && (
              <Button
                variant="outlined"
                onClick={() => {
                  const listingURL = data['listing_url'] ? data['listing_url'] : `airbnb.com/rooms/${data['listingID']}`;
                  window.open('https://www.' + listingURL, 'nofollow');
                }}
                sx={{
                  paddingLeft: '10px',
                  margin: '10px',
                  width: '133px',
                  backgroundColor: COLOR_SUCCESS_BACKGROUNG,
                  color: COLOR_SUCCESS_1,
                  borderColor: COLOR_SUCCESS_BACKGROUNG,
                  '&:hover': {
                    borderColor: COLOR_SUCCESS_1,
                  },
                }}
              >
                View Listing
              </Button>
            )}
          </Grid>

          {isCompListing && (
            <Grid item xs={9}>
              <UserListingInfoBar listing={data} />
            </Grid>
          )}
        </Grid>

        <Grid item xs={1} sm={1} md={1} lg={1} sx={{ cursor: 'pointer' }} onClick={() => onClose()}>
          <CloseRoundedIcon style={{ color: COLOR_RED, fontSize: 40 }} />
        </Grid>
      </Grid>
      {isMobileScreen && data['last_seen'] && (
        <div style={{ margin: '0px 0px 8px 10px' }}>
          <InfoTooltip
            title={
              <Typography variant="body2">We update listing status every Wednesday.</Typography>
            }
          >
            <Alert severity="info">
              <Typography variant="body2">
                This listing was last seen active by our system on {data['last_seen']}
              </Typography>
            </Alert>
          </InfoTooltip>
        </div>
      )}
    </>
  );
};

export default TopBar;
